import React from 'react';
import { Text } from '../Typography';
import { useLinkClasses } from './useLinkClasses';
/**
 * `Link` is used primarily for navigation.
 * It follows the [WAI-ARIA Link Pattern](https://www.w3.org/TR/wai-aria-practices/#link).
 * `Link` composes the `Text` component. Renders `a`.
 *
 * @see https://fe-docs.int.getresponse.com/gr-ui-neo/index.html?path=/docs/components-link--page
 */
export const Link = React.forwardRef(({ children, variant, fontSize, fontWeight, letterSpacing, align, isTruncated, color = 'sea', lineHeight, ...boxProps }, ref) => {
    const classes = useLinkClasses();
    const textProps = variant
        ? { variant, align, isTruncated }
        : { lineHeight, fontSize, fontWeight, letterSpacing, align, isTruncated };
    return (React.createElement(Text, { ref: ref, className: classes.link, tag: "a", color: color, colorHovered: color, ...textProps, ...boxProps }, children));
});
